import fp from 'lodash/fp';
import React from 'react';

import { Text, DraggablePopup } from 'Modules/ui';
import { useTranslation } from 'Modules/core/i18n';

import styles from './index.module.scss';


const RenderAmount = ({ data, title }) => data && data !== 0 ? (
    <>
        <Text component='span' textType='bold'>
            {title}:
        </Text>
        &nbsp;{data}&nbsp;₽
        <br />
    </>
) : null;

export const AmountsDraggablePopup = ({ count, amounts, buttons }) => {
    const { t } = useTranslation('amountSuppliesPopup');
    return (
        <DraggablePopup storageKey='suppliesPopup' buttons={buttons}>
            <Text component='div' textType='bold' className={styles.count}>
                {t('count', { count })}
            </Text>
            <Text component='div' className={styles.amount}>
                {fp.pipe(
                    fp.toPairs,
                    fp.map(([key, value]) => (
                        <RenderAmount key={key} data={value} title={t(key)} />
                    )),
                )(amounts)}
            </Text>
        </DraggablePopup>
    );
};
